import { useLanguage } from '../contexts/LanguageContext'

/**
 * Fixed marketing copy block for homepage / blog (SEO & AI discovery).
 */
export function MarketingAiSummary({ variant = 'landing' }) {
  const { t } = useLanguage()
  return (
    <section
      className={`marketing-ai-summary marketing-ai-summary--${variant}`}
      aria-label={t('marketing.aiSummary.ariaLabel')}
    >
      <div className="marketing-ai-summary__inner">
        <p className="marketing-ai-summary__text">{t('marketing.aiSummary.p1')}</p>
        <p className="marketing-ai-summary__text">{t('marketing.aiSummary.p2')}</p>
        <p className="marketing-ai-summary__text">{t('marketing.aiSummary.p3')}</p>
        <p className="marketing-ai-summary__text marketing-ai-summary__text--meta">{t('marketing.aiSummary.p4')}</p>
      </div>
    </section>
  )
}
